import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';

export default function Dashboard() {
  const navigate = useNavigate();
  const userName = localStorage.getItem('userName');
  const [company, setCompany] = useState({ BusinessName: '' });

  useEffect(() => {
    async function fetchCompany() {
      try {
        const res = await api.get('/settings/get');
        if (res.data && res.data.BusinessName) setCompany(res.data);
      } catch (err) {
        setCompany({ BusinessName: '' });
      }
    }
    fetchCompany();
  }, []);

  const cards = [
    { title: 'Create Invoice', path: '/invoice', icon: '🧾' },
    { title: 'Sales Invoices', path: '/invoices', icon: '📋' },
    { title: 'View Reports', path: '/reports', icon: '📊' },
    { title: 'Company Settings', path: '/settings', icon: '⚙️' },
    { title: 'Manage Customers', path: '/customers', icon: '👥' },
    { title: 'Payments', path: '/invoices', icon: '💳' },
    { title: 'Manage Logo', path: '/logo', icon: '🖼️' },
    { title: 'Manage QR Code', path: '/qrcode', icon: '🔳' },
     { title: 'Manage Products', path: '/products', icon: '🛒' },
       { title: 'Manage Suppliers', path: '/suppliers', icon: '🚚' },   
       { title: 'Purchase Bills', path: '/purchase-bills', icon: '📦' },
         { title: 'Manage Cash/Bank Accounts', path: '/cashbank-accounts', icon: '🏦' },
         { title: 'Cash/Bank Book', path: '/cashbook', icon: '📒' },



  ];

  // Card glass style
const cardStyle = {
  borderRadius: '1rem',
  boxShadow: '0 2px 14px 0 rgba(52, 96, 160, 0.13)',
  background: 'rgba(255,255,255,0.93)',
  backdropFilter: 'blur(3px)',
  border: '1px solid rgba(200,210,255,0.17)',
  transition: 'all 0.18s',
  cursor: 'pointer',
  minHeight: 70,         // 👈 Smaller height
  margin: '0.1rem 0',    // 👈 Less vertical margin
  padding: '0.1rem 0.4rem', // 👈 Add a bit of padding inside
};
  const cardHover = {
    boxShadow: '0 7px 30px 0 rgba(52, 100, 200, 0.18)',
    transform: 'scale(1.04) translateY(-5px)',
    background: 'rgba(240,248,255,0.97)',
  };

const iconStyle = {
  fontSize: '1.5rem',   // 👈 Smaller icon
  marginBottom: '0.1rem',
  color: '#3773ec',
  filter: 'drop-shadow(0 2px 6px #dbecfa88)',
};
  const [hovered, setHovered] = React.useState(-1);

  // Footer style
  const footerStyle = {
    width: '100%',
    textAlign: 'center',
    background: 'rgba(230,238,247,0.93)',
    color: '#4c618a',
    fontSize: 15,
    padding: '14px 0 8px 0',
    letterSpacing: 0.3,
    fontWeight: 500,
    position: 'fixed',
    left: 0,
    bottom: 0,
    zIndex: 5,
    borderTop: '1.5px solid #d2e2f7',
    boxShadow: '0 -1px 10px 0 #d9e6f7bb',
  };

  return (
    <div
      className="min-vh-100 pb-5"
      style={{
        background: 'linear-gradient(120deg, #c2e9fb 0%, #81a4fd 100%)',
        paddingBottom: 80,
      }}
    >
      {/* Topbar */}
      <div className="container pt-4">
        <div className="d-flex flex-wrap justify-content-between align-items-center mb-4">
          <div style={{
            fontWeight: 700,
            fontSize: 22,
            color: '#244077',
            letterSpacing: 0.5,
            textShadow: '0 2px 7px #e7f0fc',
            flex: 1,
          }}>
            {/* Show Company Name */}
            {company.BusinessName && (
              <span>
                <span style={{ color: '#4060ba', fontSize: 16, fontWeight: 500, marginRight: 8 }}>
                  {company.BusinessName}
                </span>
                <span style={{ color: '#244077', fontSize: 19, fontWeight: 700 }}>
                  Dashboard
                </span>
              </span>
            )}
            {!company.BusinessName && (
              <span>Dashboard</span>
            )}
          </div>
          <div className="dashboard-welcome text-end ms-2" style={{ color: '#3764b2', fontWeight: 600, fontSize: 17 }}>
            👋 {userName}
          </div>
          <button
            className="btn btn-danger btn-sm px-4 ms-3 mt-2 mt-md-0"
            style={{
              borderRadius: 20,
              fontWeight: 600,
              fontSize: 15,
              boxShadow: '0 1px 8px #ffa5a58a',
              letterSpacing: 0.3
            }}
            onClick={() => {
              localStorage.clear();
              navigate('/login');
            }}
          >
            Logout
          </button>
        </div>
        {/* Cards Grid */}
        <div className="row g-3">
          {cards.map((card, idx) => (
            <div className="col-12 col-sm-6 col-md-4 col-lg-3" key={card.title}>
              <div
                className="h-100"
                style={hovered === idx ? { ...cardStyle, ...cardHover } : cardStyle}
                tabIndex={0}
                onClick={() => navigate(card.path)}
                onKeyDown={e => e.key === 'Enter' && navigate(card.path)}
                onMouseEnter={() => setHovered(idx)}
                onMouseLeave={() => setHovered(-1)}
                role="button"
                aria-label={card.title}
              >
                <div className="d-flex flex-column align-items-center justify-content-center h-100 py-4">
                  <span style={iconStyle}>{card.icon}</span>
                  <h6 style={{
                    fontWeight: 600, fontSize: 17, letterSpacing: 0.3, color: '#224',
                    marginBottom: 0, marginTop: 2,
                  }}>
                    {card.title}
                  </h6>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Sticky Footer */}
      <footer style={footerStyle}>
        © {new Date().getFullYear()} {company.BusinessName || 'GST Invoice Portal'} &middot; Powered by InfoKshetra pvt ltd
      </footer>
    </div>
  );
}
